import { Routes } from '@angular/router';
import { Login } from './features/login/login';
import { Dashboard } from './features/dashboard/dashboard';
import { ServiceRequests } from './features/service-requests/service-requests';
import { ServiceRequestHistory } from './features/service-request-history/service-request-history';
import { ServiceRequestDetails } from './features/service-request-details/service-request-details';
import { MyWorkshops } from './features/my-workshops/my-workshops';
import { SearchWorkshops } from './features/search-workshops/search-workshops';
import { authGuard } from '@core/guards/auth.guard';
import { rootRedirectGuard } from '@core/guards/root-redirect.guard';
import { MyAccount } from '@features/my-account/my-account';

export const routes: Routes = [
  {
    path: '',
    canActivate: [rootRedirectGuard],
    component: Login
  },
  {
    path: 'login',
    component: Login
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    component: Dashboard
  },
  {
    path: 'service-requests',
    canActivate: [authGuard],
    component: ServiceRequests
  },
  {
    path: 'service-request-history',
    canActivate: [authGuard],
    component: ServiceRequestHistory
  },
  {
    path: 'service-request-details/:id',
    canActivate: [authGuard],
    component: ServiceRequestDetails
  },
  {
    path: 'my-account',
    canActivate: [authGuard],
    component: MyAccount
  },
  {
    path: 'my-workshops',
    canActivate: [authGuard],
    component: MyWorkshops
  },
  {
    path: 'search-workshops',
    canActivate: [authGuard],
    component: SearchWorkshops
  },
{ path: '**', canActivate: [rootRedirectGuard], component: Login }
];
